var chunkToChildrenMap = {
	"1151": [
		4824,
		2249
	],
	"7534": [
		4824,
		2249
	]
};
__webpack_require__.f.prefetch = (chunkId, promises) => (Promise.all(promises).then(() => {
	var chunks = chunkToChildrenMap[chunkId];
	Array.isArray(chunks) && chunks.map(__webpack_require__.E);
}));